import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div
                className="app-shell flex items-center justify-center"
                data-testid="auth-loading"
            >
                <div className="h-10 w-10 rounded-full border-2 border-foreground/20 border-t-foreground animate-spin" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    // Mandatory onboarding — hard-block every route except the onboarding
    // pages until `users.onboarded === true`. Demo-loop accounts repeat this
    // on every login (auth context resets the flag server-side), so they
    // also fall through this guard naturally.
    if (!user.onboarded && !location.pathname.startsWith("/onboarding")) {
        return <Navigate to="/onboarding" replace />;
    }
    return children;
}
